import { getFirestore, setDoc, deleteDoc, doc, onSnapshot, collection, query, getDocs, where, orderBy, getDoc, deleteField, limit, startAfter } from "firebase/firestore";

const db = getFirestore();

const adminModule = {
  namespaced: true,
  state: () => ({
    loading: false,
    bookingError: undefined,
    bookings: [],
    charges: [],
    wastes:[],
    bookingData: [],
    adminDisposalQuery: undefined,
    adminDisposalPageEnd: false,
    driverDisposalQuery: undefined,
    driverDisposalPageEnd: false,
    chargesQuery: undefined,
    chargesPageEnd: false,
    allBookingQuery: undefined,
    allBookingPageEnd: false
  }),
  getters: {
    getLoading: (state) => state.loading,
    getBookings: (state) => state.bookings,
    getCharges: (state) => state.charges,
    getScheduledBookings: (state) => state.charges.filter((charge) => charge.status === 'SCHEDULED'),
    getBookingError: (state) => state.bookingError,
    getBookingsByStatus: (state) => (status) => (type) => state.bookings.filter((booking) => booking.status.status === status && booking.status.type === type && booking.vehicle.type.toLowerCase() != 'truck'),
    getTruckBookingsByStatus: (state) => (status) => { return state.bookings.filter((booking) => booking.vehicle.type.toLowerCase() === 'truck' && booking.status.status === status) },
    getWaste: (state) => state.wastes,
    getData: (state) => state.bookingData,
    getAdminDisposals: (state) => state.bookings,
    getDriverDisposals: (state) => state.bookings, 
    getAdminDisposalQuery: (state) => state.adminDisposalQuery,
    getAdminDisposalPageEnd: (state) => state.adminDisposalPageEnd,
    getDriverDisposalQuery: (state) => state.driverDisposalQuery,
    getDriverDisposalPageEnd: (state) => state.driverDisposalPageEnd,
    getChargesQuery: (state) => state.chargesQuery,
    getChargesPageEnd: (state) => state.chargesPageEnd,
    getAllBookingQuery: (state) => state.allBookingQuery,
    getAllBookingPageEnd: (state) => state.allBookingPageEnd
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setBookingError(state, error) {
      state.bookingError = error;
    },
    setCharges(state, bookings){
      state.charges = bookings
    },
    setBookings(state, bookings) {
      state.bookings = bookings;
    },
    setWastes(state, wastes){
      state.wastes = wastes;
    },
    setData(state, bookingData){
      state.bookingData = bookingData;
    },
    setAdminDisposals(state, bookings){
      state.bookings = bookings;
    },
    setDriverDisposals(state, bookings){
      state.bookings = bookings;
    },
    updateBooking(state, booking) {
      state.bookings = state.bookings.map((b) => {
        if (b.id === booking.id)
          return booking;
        else return b;
      });
    },
    setAdminDisposalQuery(state, query){
      state.adminDisposalQuery = query;
    },
    setAdminDisposalPageEnd(state, page){
      state.adminDisposalPageEnd = page;
    },
    setDriverDisposalQuery(state, query){
      state.driverDisposalQuery = query
    },
    setDriverDisposalPageEnd(state, page){
      state.driverDisposalPageEnd = page
    },
    setChargesQuery(state, query){
      state.chargesQuery = query;
    },
    setChargesPageEnd(state, page){
      state.chargesPageEnd = page;
    },
    setAllBookingsQuery(state, query){
      state.allBookingQuery = query;
    },
    setAllBookingPageEnd(state, page){
      state.allBookingPageEnd = page;
    }

  },
  actions: {
    updateBooking(context, booking) {
      context.commit('setLoading', true);
      setDoc(doc(db, 'bookings', booking.id), booking, { merge: true })
      .then(() => {
        context.commit('updateBooking', booking);
        context.commit('setLoading', false);
        window.location.reload();
      })
      .catch((error) => {
        context.commit('setLoading', false);
        context.commit('setBookingError', error);
        alert(error);
      });
    },
    updateToCollectionBooking(context, booking){
      context.commit('setLoading', true);
      getDoc(doc(db, 'bookings', booking.parentBookingId))
      .then(async (snapshot) => {
        const orderNumber = snapshot.data().orderNumber.number;
        await setDoc(doc(db, 'bookings', booking.parentBookingId), {
          status:{
            origin: 'DELIVERY'
          }
        }, { merge: true })
        .then(async () => {
          await setDoc(doc(db, 'bookings', booking.keyId), {
            orderNumber:{
              number: orderNumber
            },
            status:{
              status: 'SCHEDULING',
              type: 'COLLECTION'
            }
          }, { merge: true })
          .then(() => {
            context.commit('updateBooking', booking);
            context.commit('setLoading', false);
            window.location.reload();
          })
        })
        .catch((error) => {
          context.commit('setLoading', false);
          context.commit('setBookingError', error);
          alert(error);
        });
      })
    },
    updateToExchangeBooking(context, booking){
      context.commit('setLoading', true);
      getDocs(query(collection(db, 'bookings'), where('orderNumber.number', '==', booking.orderNumber), where('status.type', '==', 'DELIVERY')))
      .then((snapshot) => {
        snapshot.docs.forEach((snap) =>{
          const bookingId = snap.id;

          setDoc(doc(db, 'bookings', bookingId), {
            status:{
              origin: deleteField(),
              locked: true
            }
          }, { merge: true })
          .then(async () => {
            await setDoc(doc(db, 'bookings', booking.keyId), {
              parentBookingId: bookingId,
              orderNumber: {
                locked: false
              },
              status:{
                status: 'SCHEDULING',
                type: 'EXCHANGE'
              }
            }, { merge: true })
  
            .then(() => {
              context.commit('updateBooking', booking);
              context.commit('setLoading', false);
              window.location.reload();
            })
            .catch((e) => console.log(e))

            
          })
          .catch((e) => console.log(e))
        })
      })
      .catch((error) => {
        context.commit('setLoading', false);
        context.commit('setBookingError', error);
        alert(error);
      });

    },
    async deleteBooking(context, bookingId) {
      context.commit('setLoading', true);
      console.log(bookingId);
      await deleteDoc(doc(db, 'bookings', bookingId))
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        context.commit('setLoading', false);
        context.commit('setBookingError', error);
        alert(error);
      });
    },
    fetchCharges(context, { bookingQuery, isLoadMore }){
      context.commit('setLoading', true);
      if(!bookingQuery){
        bookingQuery = query(
          collection(db, 'bookings'), 
          orderBy('orderNumber.id', 'desc'),
          limit(500)
        );
        context.commit('setChargesQuery', bookingQuery);
      }
      onSnapshot(bookingQuery, async(snapshot) =>{
        context.commit('setLoading', true);
        if(!isLoadMore){
          try {
            const bookings = [];
            snapshot.forEach((booking) => {
              bookings.push({ ...booking.data(), id: booking.id });
            });
            const bookingData = bookings.map((booking) => {
              let actualDate = new Date(booking.timeStamp.seconds * 1000);
              if(booking.customer && booking.status.status != 'QUOTE'){
                return {
                  bookingId: booking.id,
                  id: booking.orderNumber.id,
                  orderNumber: booking.orderNumber.number,
                  date: booking.preferredDate + '\n' + booking.preferredTime, 
                  actualDate: actualDate.getDate() + "/" + (actualDate.getMonth() + 1) + "/" + actualDate.getFullYear() + " T " + (actualDate.getHours()) + ":" + (actualDate.getMinutes()+1)+ ":" + (actualDate.getSeconds()+1),
                  customer: booking.customer.firstName + ' ' + booking.customer.lastName,
                  company: booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName + " " + booking.customer.lastName,
                  address: booking.capturedAddress,
                  wasteName: booking.waste.name,
                  vehicleName: booking.vehicle.name,
                  driverName: booking.driver? booking.driver.name : 'Processing...', 
                  status: booking.status.status,
                  type: booking.vehicle.type.includes('Truck') ? 'LOAD' : booking.status.type,
                  cost: booking.status.type == 'COLLECTION' && booking.vehicle.name.includes('Dumpster') ? 0 : booking.promotion ? `Promo ${booking.cost.value}` : booking.cost.value
                }
              }
            });
            context.commit('setCharges', bookingData);
          } catch (error) {
            console.log(error);
          } finally {
            context.commit('setLoading', false);
          }
        }
        if(isLoadMore){
          try{
            const bookings = [];
            const currentQuery = await getDocs(bookingQuery);
            
            let lastVisible = currentQuery.docs[currentQuery.docs.length - 1];
  
            currentQuery.forEach((booking) => {
              bookings.push({...booking.data(), id: booking.id});
            })
            const bookingData = bookings.map((booking) => {
              // Transform your data and return the desired structure
              let actualDate = new Date(booking.timeStamp.seconds * 1000);
              if(booking.customer && booking.status.status != 'QUOTE'){
                return {
                  bookingId: booking.id,
                  id: booking.orderNumber.id,
                  orderNumber: booking.orderNumber.number,
                  date: booking.preferredDate + '\n' + booking.preferredTime, 
                  actualDate: actualDate.getDate() + "/" + (actualDate.getMonth() + 1) + "/" + actualDate.getFullYear() + " T " + (actualDate.getHours()) + ":" + (actualDate.getMinutes()+1)+ ":" + (actualDate.getSeconds()+1),
                  customer: booking.customer.firstName + ' ' + booking.customer.lastName,
                  company: booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName + " " + booking.customer.lastName,
                  address: booking.capturedAddress,
                  wasteName: booking.waste.name,
                  vehicleName: booking.vehicle.name,
                  driverName: booking.driver? booking.driver.name : 'Processing...', 
                  status: booking.status.status,
                  type: booking.vehicle.type.includes('Truck') ? 'LOAD' : booking.status.type,
                  cost: booking.status.type == 'COLLECTION' && booking.vehicle.name.includes('Dumpster') ? 0 : booking.promotion ? `Promo ${booking.cost.value}` : booking.cost.value
                }
              }
            });
    
            context.commit('setCharges', bookingData);
  
            if(currentQuery.size < 500){
              context.commit('setChargesPageEnd', true);
            }
            bookingQuery = query(
              collection(db, 'bookings'), 
              orderBy('orderNumber.id', 'desc'),
              startAfter(lastVisible),
              limit(500)
            );
            context.commit('setChargesQuery', bookingQuery);
            context.commit('setLoading', false);
          }
          catch(error){
            console.log(error);
          }
          finally {
            context.commit('setLoading', false);
          }
        }
      })
    },
    fetchBookings(context) {
      context.commit('setLoading', true);
      onSnapshot(collection(db, 'bookings'), () => {
        context.commit('setLoading', true);
        const q = query(collection(db, 'bookings'), where('status.status', '!=', 'DISPOSED'));
        getDocs(q)
        .then((snapshot) => {
          const bookings = [];
          snapshot.forEach((booking) => {
            bookings.push({...booking.data(), id: booking.id});
          });
          context.commit('setBookings', bookings);
          context.commit('setLoading', false);
        })
        .catch((error) => {
          context.commit('setLoading', false);
          context.commit('setBookingError', error);
        });
      })

    },
    async fetchAdminDisposals(context, bookingQuery) {
      context.commit('setLoading', true);
      if(!bookingQuery){
        bookingQuery = query(
          collection(db, 'bookings'), 
          where('status.status', '==', 'DISPOSED'),
          orderBy('orderNumber.id', 'desc'), 
          limit(500)
        );
        context.commit('setAdminDisposalQuery', bookingQuery);
      }
      try{
        const bookings = [];
        const currentQuery = await getDocs(bookingQuery);
        let lastVisible = currentQuery.docs[currentQuery.docs.length - 1];

        currentQuery.forEach((booking) => {
          bookings.push({...booking.data(), id: booking.id});
        })
        context.commit('setAdminDisposals', bookings);
        if (currentQuery.size < 500) {
          context.commit('setAdminDisposalPageEnd', true);
        }

        bookingQuery = query(
          collection(db, 'bookings'), 
          where('status.status', '==', 'DISPOSED'), 
          orderBy('orderNumber.id', 'desc'), 
          startAfter(lastVisible), 
          limit(500)
        );
        context.commit('setAdminDisposalQuery', bookingQuery);
        context.commit('setLoading', false);
      }
      catch(error){
        console.log(error);
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
      }
    },
    async fetchDriverDisposals(context, bookingQuery) {
      context.commit('setLoading', true);
      let myQuery = bookingQuery.query;
      if(!myQuery){
        myQuery = query(
          collection(db, 'bookings'), 
          where('status.status', '==', 'DISPOSED'), 
          where('driver.id', '==', bookingQuery.driverId),
          orderBy('orderNumber.id', 'desc'),
          limit(500)
        );
        context.commit('setDriverDisposalQuery', myQuery);
      }
      try{
        const bookings = [];
        const currentQuery = await getDocs(myQuery);
        let lastVisible = currentQuery.docs[currentQuery.docs.length - 1];

        currentQuery.forEach((booking) => {
          bookings.push({...booking.data(), id: booking.id});
        })
        context.commit('setDriverDisposals', bookings);
        if (currentQuery.size < 500) {
          context.commit('setDriverDisposalPageEnd', true);
        }
        myQuery = query(
          collection(db, 'bookings'), 
          where('status.status', '==', 'DISPOSED'), 
          where('driver.id', '==', bookingQuery.driverId),
          orderBy('orderNumber.id', 'desc'),
          startAfter(lastVisible),
          limit(500)
        )
        context.commit('setLoading', false);
        context.commit('setDriverDisposalQuery', myQuery);
      }
      catch(error){
        console.log(error);
        context.commit('setLoading', false);
      }
    },
    fetchWastes(context){
      getDocs(collection(db, 'waste-types'))
      .then((snapshot) => {
        const wastes = [];
        snapshot.forEach((snap) => {
          wastes.push({...snap.data()})
        });
        context.commit('setWastes', wastes);
      })
      .catch((err) => console.log(err));
    },
    async fetchBookingGraphData(context){
      context.commit('setLoading', true);
      let bookings = [0,0,0,0,0,0,0,0];
      let arr1 = []; 
      let arr2 = []; 
      let arr3 = [];
      let arr4 = []; 
      let arr5 = [];
      let arr6 = [];
      let arr7 = [];
      let arr8 = [];
      getDocs(collection(db, 'bookings'))
      .then((snapshot) => {
        snapshot.forEach((snap) => {
          const data = snap.data();
          if(data.status.status == "SCHEDULING" && data.status.type == "DELIVERY"){
            arr1.push(data);
            bookings[0] = arr1.length;
          }
          if(data.status.status == "SCHEDULED" && data.status.type == "DELIVERY"){
            arr2.push(data);
            bookings[1] = arr2.length;
          }
          if(data.status.status == "SCHEDULING" && data.status.type == "EXCHANGE"){
            arr3.push(data);
            bookings[2] = arr3.length;
          }
          if(data.status.status == "SCHEDULED" && data.status.type == "EXCHANGE"){
            arr4.push(data);
            bookings[3] = arr4.length;
          }
          if(data.status.status == "SCHEDULING" && data.status.type == "COLLECTION" && data.vehicle.type == "Dumpster"){
            arr5.push(data);
            bookings[4] = arr5.length;
          }
          if(data.status.status == "SCHEDULED" && data.status.type == "COLLECTION" && data.vehicle.type == "Dumpster"){
            arr6.push(data);
            bookings[5] = arr6.length;
          }
          if(data.status.status == "SCHEDULING" && data.status.type == "COLLECTION" && data.vehicle.type == "Truck"){
            arr7.push(data);
            bookings[6] = arr7.length;
          }
          if(data.status.status == "SCHEDULED" && data.status.type == "COLLECTION" && data.vehicle.type == "Truck"){
            arr8.push(data);
            bookings[7] = arr8.length;
          }
        })
        context.commit('setData', bookings);
        context.commit('setLoading', false);
      })
    },
    async fetchWasteType(context, booking){
      context.commit('setLoading', true);
      //console.log(booking)
      await getDocs(query(collection(db, 'service-provider-areas')))
      .then((snapshot) => {
        snapshot.docs.forEach((snap) => {
          let code = Number.parseInt(booking.postCode);
          if(code >= snap.data().postalCodeStart &&  code <= snap.data().postalCodeEnd){
            snap.data().wasteTypes.forEach((waste) => {
              if(waste.name == booking.wasteName.name){
                waste.vehicles.forEach(async (v) => {
                  if (v.name == booking.vehicleName){
                    const cost = v.cost
                    await this.dispatch('updateBooking', {
                      id: booking.keyId,
                      waste: booking.wasteName,
                      cost:{
                        currency: 'USD',
                        Symbol: '$',
                        value: cost
                      }
                    })
                  }
                });
              }
            })
            context.commit('setLoading', false);
          }
        })
      })
      .catch((err) => {
        console.log(err);
        context.commit('setLoading', false);
      })

    }
  }
}

export default adminModule;